export default function slider() {
  if ($('.js-feature-slider').length) {
    $('.js-feature-slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: true,
          },
        },
      ],
    });

    $('.js-feature-nav li').on('click', function () {
      const slideIndex = $(this).data('slide');
      $('.js-feature-nav li').removeClass('active');
      $('.js-feature-slider').slick('slickGoTo', slideIndex - 1);
      $(this).addClass('active');
    });

    $('.js-feature-slider').on('afterChange', function (event, slick, currentSlide) {
      $('.js-feature-nav li').removeClass('active');
      const targetItem = $('.js-feature-nav li').eq(currentSlide);
      targetItem.addClass('active');
    });
  }
};
